import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useAdminModuleListV2 = () => {
  const service = useServices().moduleListV2Service;
  return useQuery({
    queryKey: ['adminModuleListV2'],
    queryFn: service.getModuleList,
    staleTime: Infinity,
  });
};
